import state from './state'
import mutations from './mutations'

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/messages/main.js